var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkout-container overflow-x-hidden"},[_c(_setup.Checkout)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }